<template>
  <section class="app-main">
    <div class="top-bar" style="display: flex">
      <el-input placeholder="输入商品名称查询" v-model="value" @change="search()" style="width: 210px; margin-right: 20px" clearable>
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button class="top-btn" type="success" plain @click="dialog = true">添加</el-button>
      <div style="flex: 1"></div>
      <el-button type="primary" @click="$router.go(-1)" style="margin-right: 30px; width: 135px">
        <i class="el-icon-d-arrow-left"></i>
        返回活动列表
      </el-button>
    </div>
    <el-card shadow="hover">
      <el-table :data="tableData" @selection-change="handleChecked" height="600">
        <el-table-column label="商品图片" align="center" prop="pic_image">
          <template slot-scope="scope">
            <m-img v-if="scope.row.pic_image" :src="scope.row.pic_image" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="min_price,max_price" align="center" label="原价" show-overflow-tooltip>
          <template slot-scope="scope" >
            <div v-if="scope.row.max_price == scope.row.min_price">
              C${{ scope.row.min_price }}
            </div>
            <div v-else>
              C${{ scope.row.min_price }} - C${{ scope.row.max_price }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="activity_min_price,activity_max_price" align="center" label="活动价" show-overflow-tooltip>
          <template slot-scope="scope" >
            <div v-if="scope.row.activity_min_price == scope.row.activity_max_price">
              C${{ scope.row.activity_min_price }}
            </div>
            <div v-else>
              C${{ scope.row.activity_min_price }} - C${{ scope.row.activity_max_price }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="off" label="是否折扣商品" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span> 
              {{scope.row.off?'是':'否'}}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column prop="sort_id" label="排序" align="center" sortable>
          <template slot-scope="scope">
            <el-input v-model="scope.row.sort_id" size="small" @change="handleSort(scope.row)" style="width: 60px;"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="off" label="是否修改价格" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.activity_min_price <= 0 ? true : false" style="color:#F56C6C">未修改</span>
            <span v-else style="color:#67C23A">已修改</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="编辑">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain @click="handlePut(scope.row)">规格修改</el-button>
            <el-button size="mini" type="danger" plain @click="handleDel(scope.row, scope.$index)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, jumper" style="padding: 10px" :total="total" :page-size="size" @current-change="loadMore"></el-pagination>
    </el-card>
    <!-- 添加的弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="1000px" center>
      <el-card shadow="never">
        <div class="m-bottom-3">
          <el-input v-model="goodsSearch" @change="searchGoods()" clearable placeholder="搜索商品" prefix-icon="el-icon-search" style="margin-right: 20px; width: 180px"></el-input>
        </div>
        <el-table :data="goodsData"   max-height="450" ref="table" style="width: 100%">
          <el-table-column label="商品图片" align="center">
            <template slot-scope="scope">
              <m-img :src="scope.row.pic_image.url"></m-img>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="min_price,max_price" align="center" label="价格" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.max_price == scope.row.min_price">
                C${{ scope.row.min_price }}
              </div>
              <div v-else>
                C${{ scope.row.min_price }} - C${{ scope.row.max_price }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="off" label="是否折扣商品" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span> 
                {{ scope.row.off ? '是' : '否' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="编辑">
            <template slot-scope="scope">
              <el-button size="mini" type="success" plain @click="handleAdd(scope.row)" :disabled="scope.row.Stock <= 0 ? true : false">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper" style="padding: 10px" :total="goodsTotal" :page-size="goodsSize" @current-change="goodsMore"></el-pagination>
      </el-card>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog title="规格修改" :visible.sync="dialogPut" :show-close="false" width="1000px" center>
      <el-card class="m-bottom-4" style="overflow-y: auto">
          <el-row class="m-bottom-4">
            <div class="sku-items-head">
              <div
                class="m-width-140"
                v-for="(item, index) in skuHead"
                :key="index"
              >
                <span>{{ item.title  }}</span>
              </div>
              <div
                class="m-width-140"
                v-for="(item, index) in skuHead"
                :key="index"
              >
                <span>{{ item.title_en }}</span>
              </div>
              <div class="m-width-100"><span>原价(C$)</span></div>
              <div class="m-width-100"><span>活动价(C$)</span></div>
              <div class="m-width-100"><span>出售价(C$)</span></div>
              <div class="m-width-160"><span>条形码</span></div>
              <div class="m-width-160"><span>变量图片</span></div>
            </div>
            <div
              class="sku-items-body"
              v-for="(it, index) in skuItems"
              :key="index"
            >
              <div
                class="m-width-140"
                v-for="(item, ind) in it.attr_data"
                :key="ind"
              >
                <el-input
                  v-model="item.attr_title"
                  size="small"
                  disabled
                ></el-input>
              </div>
              <div
                class="m-width-140"
                v-for="(item, ind) in it.attr_data"
                :key="ind"
              >
                <el-input
                  v-model="item.attr_title_en"
                  size="small"
                  disabled
                ></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.cost_price" size="small" disabled></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.activity_price" size="small" :disabled="off != 0 ? true : false"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.price" size="small" disabled></el-input>
              </div>
              <div class="m-width-160">
                <el-input v-model="it.barcode" size="small" disabled></el-input>
              </div>
              <div class="m-width-160" style="text-align: center">
                <m-img v-if="it.pic_image"  :src="it.pic_image.url" />
              </div>
            </div>
          </el-row>
        </el-card>
        <el-card>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 提交修改： </el-col>
            <el-col :span="22">
              <el-button @click="handleBtn()" type="success" plain
                >确认修改</el-button
              >
            </el-col>
          </el-row>
        </el-card>
    </el-dialog>
  </section>
</template>
<script>
import {  landing_goods_list, landing_add_goods, landing_edit_goods_sku, landing_del_goods } from "@/api/market.js";
import { goods_sku, goods_list } from "@/api/goods.js"
import MImg from "@/components/Image";

export default {
  components: { MImg },
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      size: 20,
      value: "",
      ids: [], // table 选中数据的 id 数组集合
      dialog: false, // 控制显示 添加弹窗
      dialogTitle: "添加商品",
      dialogPut: false, // 修改价格弹窗
      // 上架商品数据
      goodsTable: [],
      goodsTotal: 0,
      goodsSize: 20,
      goodsPage: 1,
      goodsSearch: "",
      id: '',
      skuItems: [],
      skuHead: [],
      off: 0
    };
  },
  methods: {
    // 主题商品列表
    getData() {
      let params = {
        activity: 3,
        page: this.page,
        activity_id:this.$route.params.id
      };
      if (this.value != "") {
        params.search = this.value;
      }
      landing_goods_list(params).then((res) => {
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.size = res.data.per_page;
        } else {
          this.tableData = [];
          this.total = 0
          this.size = 20
        }
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    loadMore(page) {
      this.page = page;
      this.getData();
    },
    // 获取上架商品
    getSales() {
      let params = {
        page: this.goodsPage,
        status: 1,
      };
      if (this.goodsSearch != "") {
        params.search = this.goodsSearch;
      }
      goods_list(params).then((res) => {
        if (res) {
          this.goodsData = res.data.data;
          this.goodsData.forEach(item => {
            item.pic_image = {
              url: item.image_url,
              id: item.image
            }
          })
          this.goodsTotal = res.data.total;
          this.goodsSize = res.data.per_page;
        } else {
          this.goodsData = []
        }
        this.$forceUpdate();
      });
    },
    goodsMore(page) {
      this.goodsPage = page;
      this.getSales();
    },
    // 搜索上架商品
    searchGoods() {
      this.goodsPage = 1;
      this.getSales();
    },
    // 添加商品
    handleAdd(row) {
      let params = {
        activity: 3,
        goods_id: row.id,
        activity_id: this.$route.params.id,
      };
      landing_add_goods(params).then((res) => {
        if (res) {
          this.getData();
          this.$message({ type: "success", message: res.msg, duration: 1500 });
        }
      });
    },
    // 排序修改
    handleSort(row) {
      let params = {
        sort_id: row.sort_id,
      }
      landing_edit_goods_sku(row.id,params).then(res =>{
        if(res) {
          this.$message({ message: res.msg, type: 'success'})
          this.tableData = this.$.sortBy(this.tableData, (it) => {
            return -it.sort_id
          })
        }
      })

    },
    // 修改商品价格
    handlePut(row){
      this.id = row.id
      this.dialogPut = true
      this.off = row.off
      goods_sku(row.goods_id).then(res =>{
        this.skuHead = []
        if(res) {
          this.skuItems = res.data
          this.skuItems.forEach(item => {
            item.pic_image = {
              url: item.sku_pic_url,
              id: item.sku_pic
            }
            if(this.off != 0) {
              item.activity_price = item.price
            }
          })
          this.skuItems.forEach(item =>{
            item.price = (item.price*1).toFixed(2)
            item.activity_price = (item.activity_price*1).toFixed(2)
            item.cost_price = (item.cost_price*1).toFixed(2)
          })
          if(res.data[0].attr_data) {
            res.data[0].attr_data.forEach((e) => {
              this.skuHead.push(e.spec_value);
            });
          }
        }
      })
    },
    // 确认修改
    handleBtn() {
      let params = {
        sku_data: this.skuItems.map(item =>({id: item.id, activity_price: item.activity_price}))
      }
      let flag = true
      this.skuItems.forEach(params =>{
        if(params.activity_price*1 > params.cost_price*1) {
          this.$message({ message: '活动价不能高于原价' })
          flag = false
        }
      })
      if(flag) {
        landing_edit_goods_sku(this.id, params).then(res =>{
          if(res) {
            this.$message({ message: res.msg, type: "success" })
            this.dialogPut = false
            this.getData();
          }
        })
      }
    },
    // 删除商品
    handleDel(row, index) {
      this.$confirm(`此操作将移除商品： ${row.name}, 是否继续?`, "提示", {
        type: "warning",
      })
        .then(() => {
          landing_del_goods(row.id).then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
              });
              this.tableData.splice(index, 1);
            }
          });
        })
        .catch(() => {});
    },
    // 监听 table 选中事件，获取选中数据的id
    handleChecked(rows) {
        this.ids = []
        rows.forEach((e) => {
        this.ids.push(e.id);
      });
    },
  },
  created() {
    this.getData();
    this.getSales();
  },
  activated() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
section {
  .line-item {
    margin-bottom: 20px;
  }
  .input-left {
    height: 40px;
    line-height: 40px;
  }
  .item-label {
    height: 40px;
    line-height: 40px;
  }
  .row-bg {
    margin-top: 25px;
  }
  .m-center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .m-width-100 {
    width: 100px;
  }
  .m-width-120 {
    width: 120px;
  }
  .m-width-140 {
    width: 140px;
  }
  .m-width-160 {
    width: 160px;
  }
  .sku-items-head{
    min-width: 900px;
    display: flex;
    background: #f5f7fa;
    border: 1px solid #e8e8e8;
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      padding: 0 8px;
      font-size: 15px;
      color: #8c939d;
      > span {
        display: inline-block;
        width: 100%;
        height: 36px;
        background: #fff;
        text-align: center;
        line-height: 36px;
        border-radius: 3px;
      }
    }
  }
  .sku-items-body{
    min-width: 900px;
    display: flex;
    border: 1px solid #e8e8e8;
    border-top: none;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 80px;
      padding: 0 8px;
      font-size: 15px;
      color: #8c939d;
    }
    .avatar-uploader-icon {
      width: 60px;
      height: 60px;
      line-height: 60px !important;
      border: 1px solid #e0e0e0;
    }
  }
  /deep/ .el-input--small .el-input__inner {
    text-align: center;
  }
}
</style>